<template>
  <div>
    <div class="order-header">
        <div class="order-title">
          <span>提交订单</span>
        </div>
    </div>
    <el-card class="cart-body">
      <div class="box">
        <div style="padding: 36px 0px 26px 0px">
          <p class="goods-info-tile">商品信息</p>
        </div>
        <el-card class="goods-info">
          <el-row style="margin: 20px">
            <el-col :span="4">
              <a href="javascript:void(0)">
                <el-image style="width: 150px;height: 100px;"
                  v-if="course.image !== undefined"
                  :src="course.image"
                  @click="toDetail">
                </el-image>
              </a>
            </el-col>
            <el-col :span="13">
              <div>
                <p style="cursor: pointer" @click="toDetail">
                  【{{course.courseType === 'O'?'技术人员培训学习':course.courseType === 'C'?'技术人员宣贯学习':''}}】
                   {{course.name}}
                </p>
                <div>
                  <el-alert
                    title="购买技术人员宣贯学习类型的课程需要绑定对应的证书 ！"
                    type="warning"
                    show-icon
                    :closable="false"
                    class="edu-alert-tag"
                    v-if="course.courseType === 'C'">
                  </el-alert>
                </div>
              </div>
            </el-col>
            <el-col :span="7">
              <div style="margin-top: 35px;">
                <span style="color: #93999f">价格 ：</span>
                <span style="color: #f01414;font-size: 18px">￥ {{course.price}}</span>
              </div>
            </el-col>
          </el-row>
        </el-card>
        <div class="goods-foot">
          <el-row>
            <el-col :span="5" style="padding-top: 32px">
              <div>
                <el-alert
                  title="请提交订单"
                  type="warning"
                  show-icon
                  :closable="false"
                  style="background-color: #FFFFFF;color: #f90">
                </el-alert>
              </div>
            </el-col>
            <el-col :span="14">
              <div style="height: 1px"></div>
            </el-col>
            <el-col :span="5">
              <div style="padding-top: 36px;float: right">
                <div>
                  <span>应付金额：</span>
                  <span class="price">￥ {{course.price}}</span>
                </div>
                <div style="margin: 32px 0 16px 0px;text-align: right">
                  <el-button type="danger" style="background-color:#f01414" @click="toPay">提交订单</el-button>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </el-card>
<!--    没有证书错误对话框-->
    <el-dialog
      :visible.sync="notHaveCredDiaVisible"
      width="40%"
      center :close-on-click-modal="false">
      <span>
        <div style="text-align: center; background-color: white">
          <el-alert id="notHaveCredDia"
            title="创建订单失败，购买技术人员宣贯学习类型的课程需要绑定对应的证书！" type="error" center show-icon
            :closable="false" style="background-color: #FFFFFF;">
          </el-alert>
        </div>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button type="warning" @click="notHaveCredDia">暂不认证</el-button>
        <el-button type="primary" @click="toCredentials" style="background-color: #25bb9b">前往认证</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    name: "confirm",
    data() {
      return {
        course: Object, // 课程对象
        notHaveCredDiaVisible: false, // 没有证书错误对话框
      }
    },
    methods: {
      notHaveCredDia(){
        //this.notHaveCredDiaVisible = false;
        window.open("about:blank", "_top").close();
      }
      ,
      async toPay() {
        const params = {
          courseId: this.course.id
        };
        const { code,content } = await this.$http.post('/business/web/order/createOrder', params);
        // 验证是否拥有证书
        if (code == '2005') {
          this.notHaveCredDiaVisible = true;
          return ;
        }
        if (content) {
          params.orderId = content;
          this.$router.push({ name: 'OrderPay', params: params });
        }
      },
      toDetail() {
        const params = {
          courseId: this.course.id
        };
        let routerName = '';
        if (this.course.courseType === 'O') {
          routerName = 'TrainDetail';
        }else if (this.course.courseType === 'C') {
          routerName = 'EduDetail';
        }
        let routeUrl = this.$router.resolve({ name: routerName, params: params });
        window.open(routeUrl.href, '_blank');
      },
      toCredentials() {
        this.notHaveCredDiaVisible = false;
        this.$router.push('/home/mine/certification');
      }
    },
    async created() {
      const courseId = this.$route.params.courseId;
      const { content } = await this.$http.get('/business/web/course/getOneById',{params:{courseId:courseId}});
      if (content) {
        this.course = content;
      }
    },
  }
</script>

<style scoped>
  .order-header {
    height: 160px;
    background: url("../../assets/img/cart-bg.png") repeat-x left bottom ;
  }
  .order-title {
    width: 60%;
    height: 120px;
    margin: 0px auto;
    line-height: 120px;
  }
  .order-title span {
    font-size: 32px;
    color: #07111b;
    font-weight: 200;
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
  }
  .cart-body {
    width: 62%;
    margin: -40px auto 0px auto;
    height: 500px;
    border-radius: 8px;
    min-width: 1100px;
  }
  .cart-body >>> .el-card__body {
    padding: 0px;
  }
  .cart-body .box {
    width: 94%;
    margin: 0px auto;
    height: 500px;
  }
  .goods-info-tile {
    margin-left: 12px;
    color: #07111b;
    font-size: 16px;
    line-height: 16px;
  }
  .goods-info {
    width: 100%;
    height: 140px;
    background-color: #f3f5f7;
  }
  .goods-foot {
    width: 100%;
    margin-top: 48px;
    border-top: 1px solid #d9dde1;
  }
  .price {
    font-size: 24px;
    color: #f01414;
  }
  .edu-alert-tag {
    background-color: #f3f5f7;
    color: #f90;
    font-size: 10px;
    margin:-10px 0px 0px -12px
  }

  #notHaveCredDia  >>> .el-alert__title {
    font-size: 16px;
    line-height: 16px;
    font-weight: bold;
  }
</style>
